export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-pagination/es/index.js
// module id = 662
// module chunks = 0 1